import React from 'react';

const STATUS_STYLES = {
  'Pendiente': {
    bg: 'bg-gradient-to-r from-gray-400 to-gray-500',
    text: 'text-white',
    border: 'border-gray-400',
    glow: 'shadow-[0_0_10px_rgba(156,163,175,0.3)]'
  },
  'En Progreso': {
    bg: 'bg-gradient-to-r from-blue-500 to-blue-600',
    text: 'text-white',
    border: 'border-blue-500',
    glow: 'shadow-[0_0_10px_rgba(59,130,246,0.4)]',
    pulse: true
  },
  'En Espera': {
    bg: 'bg-gradient-to-r from-yellow-500 to-amber-500',
    text: 'text-white',
    border: 'border-yellow-500',
    glow: 'shadow-[0_0_10px_rgba(245,158,11,0.4)]',
    pulse: true
  },
  'Devuelta': {
    bg: 'bg-gradient-to-r from-red-500 to-red-600',
    text: 'text-white',
    border: 'border-red-500',
    glow: 'shadow-[0_0_10px_rgba(239,68,68,0.4)]',
    pulse: true
  },
  'Completada': {
    bg: 'bg-gradient-to-r from-green-500 to-emerald-600',
    text: 'text-white',
    border: 'border-green-500',
    glow: 'shadow-[0_0_10px_rgba(16,185,129,0.4)]'
  }
};

const StatusBadge = ({ status, className = '', waitingType = null }) => {
  const style = STATUS_STYLES[status] || STATUS_STYLES['Pendiente'];

  return (
    <span
      className={`inline-flex items-center px-3 py-1.5 rounded-full text-xs font-bold border-2 ${style.bg} ${style.text} ${style.border} ${style.glow} ${style.pulse ? 'animate-pulse' : ''} ${className}`}
      data-testid="status-badge"
    >
      {status}
      {status === 'En Espera' && waitingType && (
        <span className="ml-1.5 opacity-90">· {waitingType}</span>
      )}
    </span>
  );
};

export default StatusBadge;
